import { modelOptions, prop } from '@typegoose/typegoose';

class CryptographyModel {
  @prop({ required: true })
  key: string;
}

@modelOptions({
  schemaOptions: { collection: 'settings' },
  options: { customName: 'settings' },
})
export class SettingsModel {
  @prop({ required: true })
  cryptography: CryptographyModel;
}
